/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import GrievanceHeader from '../../../../components/common/layout/GrievanceHeader';
import AllResolveComplaint from '../../../../components/corporate/grievance/Home/AllResolveComplaint';
import { dataActions } from '../../../../shared/store/data-Slice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Canonical from '../../../../components/common/layout/Canonical';

const ResolveComplaint = ({ popup }: any) => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();

    useEffect(() => {
        popup === "complaint" ? dispatch(dataActions.setComplaintDetail(true)) : dispatch(dataActions.setComplaintDetail(false))
    }, [popup])

    return (
        <div className='w-full h-full min-h-[calc(100vh-100px)] mm:min-h-[calc(100vh-65px)]'>
            <Canonical />
            <div style={{ background: "linear-gradient(178deg, #FFF -54.32%, #C9F8FF 243.19%)" }} className="flex items-center justify-center w-full h-full rounded-b-[25px] lg:rounded-b-[50px] flex-col">
                <GrievanceHeader />
                <div className="container h-full py-[25px] md:py-[40px] xlx:py-[45px] flex flex-col">
                    <div className="flex flex-col gap-[2px] w-full">
                        <h2 className="text-[2.188rem] text-[#242555] font-bold uppercase">{t("grievance.resolve_complaint.banner.title")}</h2>
                        <h5 className="text-[#3D3D3D] font-medium">{t("grievance.resolve_complaint.banner.desc")}</h5>
                    </div>
                </div>
            </div>
            <AllResolveComplaint />
        </div>
    );
};

export default ResolveComplaint;